/* ============================================================
   arthene — Galerie (adaptives Werk-Raster)

   Portiert aus prototypes/assets/arthene-galerie.js. Im Theme schreibt
   Liquid die Karten, das Skript macht nur noch drei Dinge:

     1. Masonry — jede Karte bekommt so viele 1-px-Zeilen, wie sie
        tatsächlich hoch ist. Genau das macht die Bildfelder beweglich:
        welches Format ein Produktbild später hat, spielt keine Rolle.
     2. Sortieren ohne Klick auf „Anwenden" (Kategorieseite: Formular
        abschicken; Seiten-Modus: Karten im Raster umsortieren).
     3. Die Filterleiste: auf- und zuklappen, Zustand merken, auf dem
        Handy der Bogen von unten, dazu Künstlersuche und Farbnamen.
     4. Gattung und Feinfilter im Seiten-Modus, wo es keine
        Shopify-Facetten gibt.

   Auf einer Kategorieseite mit eingerichteten Filtern übernimmt Shopify
   Filtern und Sortieren serverseitig — dann ist die Gattung eine Liste
   echter Links und die Leiste ein gewöhnliches GET-Formular; das Skript
   rührt beides inhaltlich nicht an.

   Die Leiste steht im CSS OFFEN — so bleibt sie ohne dieses Skript
   bedienbar. Zugeklappt wird sie von einem winzigen Inline-Skript in der
   Section, noch bevor gezeichnet wird; hier kommt nur das Umschalten,
   das Merken und die Bewegung dazu.
   ============================================================ */
(function () {
  'use strict';

  var ABSTAND_KLEIN = 30; // vertikaler Kartenabstand < 760 px
  var ABSTAND_GROSS = 42; // ... darüber

  function ordnen(raster) {
    var karten = raster.querySelectorAll('.werk');
    var sichtbar = 0;
    Array.prototype.forEach.call(karten, function (k) { if (!k.hidden) sichtbar++; });
    /* Ohne sichtbare Werke (alles weggefiltert) zurück ins normale Raster,
       damit der „Kein Werk passt"-Hinweis seine volle Höhe bekommt. */
    if (!sichtbar) { raster.classList.remove('is-masonry'); return; }
    raster.classList.add('is-masonry');
    var abstand = window.innerWidth < 760 ? ABSTAND_KLEIN : ABSTAND_GROSS;
    /* Erst alle Höhen lesen, dann alle Spannweiten schreiben — sonst
       rechnet der Browser zwischen jeder Karte das Layout neu. */
    var hoehen = [];
    Array.prototype.forEach.call(karten, function (k) {
      hoehen.push(k.hidden ? 0 : k.getBoundingClientRect().height);
    });
    Array.prototype.forEach.call(karten, function (k, i) {
      k.style.gridRowEnd = hoehen[i] ? 'span ' + Math.round(hoehen[i] + abstand) : 'span 1';
    });
  }

  function initGalerie(wurzel) {
    var raster = (wurzel || document).querySelector('[data-raster]');
    if (!raster || raster.dataset.galerieBereit === '1') return;
    raster.dataset.galerieBereit = '1';

    var bereich = raster.closest('.galerie') || document;
    var neuOrdnen = function () { ordnen(raster); };

    /* Werkzeugleiste erst freigeben, wenn sie auch wirkt. */
    var leiste = bereich.querySelector('.galerie__bar');
    if (leiste) leiste.classList.add('is-bereit');

    /* Kategorieseite: Auswahl im Sortier-Formular genügt, der Knopf entfällt. */
    var sortForm = bereich.querySelector('[data-galerie-sortform]');
    if (sortForm) {
      var knopf = sortForm.querySelector('.galerie__go');
      if (knopf) knopf.hidden = true;
      var sortFeld = sortForm.querySelector('select');
      if (sortFeld) sortFeld.addEventListener('change', function () { sortForm.submit(); });
    }

    /* ---- Die Filterleiste ----
       Auf- und zuklappen über eine Klasse am <html>; dieselbe Klasse
       setzt das Inline-Skript der Section vor dem ersten Zeichnen. */
    var leiste = bereich.querySelector('.seite');
    var aufbau = bereich.querySelector('.aufbau');
    var klapp = bereich.querySelector('[data-galerie-klapp]');
    var wurzelKlassen = document.documentElement.classList;

    if (leiste && aufbau) {
      var SCHLUESSEL = 'arthene-filter-offen';
      var handy = function () { return window.matchMedia('(max-width:900px)').matches; };
      var merke = function (offen) {
        try { localStorage.setItem(SCHLUESSEL, offen ? '1' : '0'); } catch (e) { /* privater Modus */ }
      };

      /* Die zugeklappte Spalte ist 0 breit, ihre Bedienelemente wären für
         Tastatur und Vorleseprogramm trotzdem erreichbar — inert hält sie
         draußen. Auf dem Handy ist die Leiste ein Bogen, dort gilt das
         nur, solange er zu ist. */
      var setzeInert = function () {
        var offen = handy()
          ? document.body.classList.contains('bogen-offen')
          : !wurzelKlassen.contains('filterleiste-zu');
        if (offen) leiste.removeAttribute('inert');
        else leiste.setAttribute('inert', '');
      };

      /* Die Bewegung erst freigeben, wenn die Seite steht — sonst führte
         der gemerkte Zustand beim Laden eine Animation vor. */
      requestAnimationFrame(function () { aufbau.classList.add('ist-bewegt'); });

      if (klapp) {
        klapp.addEventListener('click', function () {
          var zu = wurzelKlassen.toggle('filterleiste-zu');
          klapp.setAttribute('aria-expanded', zu ? 'false' : 'true');
          merke(!zu);
          setzeInert();
          /* Die Karten werden schmaler oder breiter — die Masonry-Höhen
             stimmen erst nach der Bewegung wieder. */
          neuOrdnen();
        });
        klapp.setAttribute('aria-expanded', wurzelKlassen.contains('filterleiste-zu') ? 'false' : 'true');
      }
      aufbau.addEventListener('transitionend', function (e) {
        if (e.propertyName === 'grid-template-columns') neuOrdnen();
      });

      /* ---- Handy: der Bogen von unten ---- */
      var bogenAuf = bereich.querySelector('[data-galerie-bogen-auf]');
      var bogenOeffnen = function () {
        document.body.classList.add('bogen-offen');
        if (bogenAuf) bogenAuf.setAttribute('aria-expanded', 'true');
        setzeInert();
        var erstes = leiste.querySelector('.seite__reset, a, button, input, select, summary');
        if (erstes) setTimeout(function () { erstes.focus(); }, 60);
      };
      var bogenSchliessen = function () {
        if (!document.body.classList.contains('bogen-offen')) return;
        document.body.classList.remove('bogen-offen');
        if (bogenAuf) { bogenAuf.setAttribute('aria-expanded', 'false'); bogenAuf.focus(); }
        setzeInert();
      };
      if (bogenAuf) bogenAuf.addEventListener('click', bogenOeffnen);
      bereich.querySelectorAll('[data-galerie-bogen-zu]').forEach(function (b) {
        b.addEventListener('click', bogenSchliessen);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') bogenSchliessen();
      });
      /* Der Fokus darf nicht hinter den Schleier wandern. */
      leiste.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' || !document.body.classList.contains('bogen-offen')) return;
        var liste = Array.prototype.filter.call(
          leiste.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'),
          function (el) { return el.offsetParent !== null || el === document.activeElement; }
        );
        if (!liste.length) return;
        var erstes = liste[0], letztes = liste[liste.length - 1];
        if (e.shiftKey && document.activeElement === erstes) { e.preventDefault(); letztes.focus(); }
        else if (!e.shiftKey && document.activeElement === letztes) { e.preventDefault(); erstes.focus(); }
      });

      window.addEventListener('resize', setzeInert);
      setzeInert();

      /* ---- Leere Preisfelder nicht mitschicken ----
         Sonst stünde „…&filter.v.price.lte=" in der Adresse: Shopify
         ignoriert das, aber geteilte Links tragen Ballast. */
      var seitenForm = bereich.querySelector('[data-galerie-seitenform]');
      if (seitenForm) {
        seitenForm.addEventListener('submit', function () {
          var leere = [];
          seitenForm.querySelectorAll('input[type="number"]').forEach(function (feld) {
            if (!feld.value) { feld.disabled = true; leere.push(feld); }
          });
          setTimeout(function () { leere.forEach(function (f) { f.disabled = false; }); }, 0);
        });
      }

      /* ---- Künstler: acht Namen, der Rest auf Wunsch ----
         Über hundert Kästchen in einer 250 px schmalen Spalte wären eine
         Rolltreppe. Gerendert werden alle (sonst ginge eine Auswahl beim
         Abschicken verloren), sichtbar sind erst acht. */
      var kListe = leiste.querySelector('.k-liste');
      if (kListe) {
        var GRENZE = 8;
        var kSuche = leiste.querySelector('[data-galerie-ksuche]');
        var kMehr = leiste.querySelector('[data-galerie-kmehr]');
        var kLeer = leiste.querySelector('[data-galerie-kleer]');
        var alleZeilen = Array.prototype.slice.call(kListe.querySelectorAll('.wahl'));
        var alleZeigen = false;
        var ohneAkzent = function (t) {
          return String(t).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        };

        var zeichneKuenstler = function () {
          var frage = kSuche ? ohneAkzent(kSuche.value.trim()) : '';
          var offen = alleZeigen || !!frage;
          var gezeigt = 0, passend = 0;
          alleZeilen.forEach(function (w) {
            var gehakt = w.querySelector('input').checked;
            var passt = !frage || ohneAkzent(w.dataset.name || '').indexOf(frage) !== -1;
            if (passt) passend++;
            /* Gewähltes bleibt immer sichtbar — sonst verschwände eine
               Auswahl aus dem Blick und würde doch mitgeschickt. */
            var zeigen = gehakt || (passt && (offen || gezeigt < GRENZE));
            if (zeigen && !gehakt) gezeigt++;
            w.hidden = !zeigen;
          });
          kListe.classList.toggle('is-lang', offen);
          if (kLeer) kLeer.hidden = passend > 0;
          if (kMehr) {
            kMehr.hidden = !!frage || passend <= GRENZE;
            kMehr.textContent = alleZeigen ? kMehr.dataset.weniger : kMehr.dataset.mehr;
          }
        };

        if (kSuche) kSuche.addEventListener('input', zeichneKuenstler);
        if (kMehr) {
          kMehr.addEventListener('click', function () { alleZeigen = !alleZeigen; zeichneKuenstler(); });
        }
        kListe.addEventListener('change', zeichneKuenstler);
        zeichneKuenstler();
      }

      /* ---- Farbe: der Name steht unter den Punkten ----
         Die Punkte tragen ihn nur als aria-label; sehend erkennt man ihn
         beim Überfahren. */
      var farben = leiste.querySelector('.farben');
      if (farben) {
        var farbName = farben.querySelector('[data-galerie-farbname]');
        var farbStand = function () {
          if (!farbName) return;
          var gewaehlt = Array.prototype.map.call(
            farben.querySelectorAll('input:checked'),
            function (i) { return i.dataset.name || i.value; }
          );
          farbName.textContent = gewaehlt.join(', ');
        };
        farben.addEventListener('mouseover', function (e) {
          var f = e.target.closest('[data-name]');
          if (f && farbName && !farben.querySelector('input:checked')) farbName.textContent = f.dataset.name;
        });
        farben.addEventListener('mouseleave', farbStand);
        farben.addEventListener('change', farbStand);
        farbStand();
      }
    }

    /* Seiten-Modus: filtern und sortieren im Browser, weil es außerhalb
       einer Kategorieseite keine Shopify-Facetten gibt. Die Chips tragen
       ihren Vergleichs-Schlüssel am Container (data-galerie-schluessel:
       kuenstler | kat | technik) — die Karten halten alle Werte als
       kleingeschriebene, |-getrennte data-Attribute bereit. */
    if (raster.hasAttribute('data-galerie-lokal')) {
      var chips    = bereich.querySelector('[data-galerie-filter]');
      var chipKey  = chips ? (chips.dataset.galerieSchluessel || 'kat') : 'kat';
      var marken   = bereich.querySelector('[data-galerie-marken]');
      var klappZahl = bereich.querySelector('[data-galerie-klapp-zahl]');
      var mobilZahl = bereich.querySelector('[data-galerie-mobil-zahl]');
      var anzahl   = bereich.querySelector('[data-galerie-anzahl]');
      /* Ein- und Mehrzahl liegen als data-Attribute am Zaehler selbst
         (sections/arthene-galerie.liquid) — in einer .js-Datei rendert Liquid
         nicht. Im Mehrzahl-Text steht {n} fuer die Zahl. Der deutsche
         Rueckfall greift nur, wenn ein Attribut einmal fehlt. */
      var werkEins  = (anzahl && anzahl.dataset.werkEins)  || '1 Werk';
      var werkViele = (anzahl && anzahl.dataset.werkViele) || '{n} Werke';
      var sortSel  = bereich.querySelector('[data-galerie-sort]');
      var suchFeld = bereich.querySelector('[data-galerie-suche]');
      var facetten = Array.prototype.slice.call(bereich.querySelectorAll('[data-galerie-facette]'));
      var preisSel = bereich.querySelector('[data-galerie-preis]');
      var verfuegbar = bereich.querySelector('[data-galerie-verfuegbar]');
      var zurueck  = bereich.querySelector('[data-galerie-reset]');
      var keine    = raster.querySelector('[data-galerie-keine]');
      var reihenfolge = Array.prototype.slice.call(raster.querySelectorAll('.werk'));

      /* Ein data-Attribut darf mehrere Werte tragen („öl|impasto") —
         verglichen wird gegen die Einzelwerte. */
      var enthaelt = function (karte, schluessel, wert) {
        return (karte.dataset[schluessel] || '').split('|').indexOf(wert) !== -1;
      };

      var anwenden = function () {
        var gewaehlt = chips ? chips.querySelector('.is-active') : null;
        var chipWert = gewaehlt ? gewaehlt.dataset.wert : 'alle';
        var sortierung = sortSel ? sortSel.value : 'empfohlen';

        /* Suche: jeder eingetippte Begriff muss im Volltext der Karte
           (data-suche: Titel, Künstler, Technik, Jahr, Tags) vorkommen. */
        var begriffe = [];
        if (suchFeld && suchFeld.value.trim()) {
          begriffe = suchFeld.value.trim().toLowerCase().split(/\s+/);
        }

        /* Feinfilter: gewählter Wert muss unter den |-getrennten Werten
           des passenden data-Attributs (data-kuenstler, data-technik, …) sein. */
        var wahl = {};
        facetten.forEach(function (f) {
          if (f.value) wahl[f.dataset.galerieFacette] = f.value;
        });

        /* Preis-Bereich: „min-max" in Cent; offenes Ende = kein max. */
        var preisMin = 0, preisMax = Infinity, preisAktiv = false;
        if (preisSel && preisSel.value) {
          var grenzen = preisSel.value.split('-');
          preisMin = parseInt(grenzen[0], 10) || 0;
          preisMax = grenzen[1] ? parseInt(grenzen[1], 10) : Infinity;
          preisAktiv = true;
        }

        var nurVerfuegbar = verfuegbar && verfuegbar.getAttribute('aria-pressed') === 'true';

        var liste = reihenfolge.slice();
        if (sortierung === 'preis-auf') liste.sort(function (a, b) { return a.dataset.preis - b.dataset.preis; });
        if (sortierung === 'preis-ab')  liste.sort(function (a, b) { return b.dataset.preis - a.dataset.preis; });
        if (sortierung === 'titel')     liste.sort(function (a, b) { return a.dataset.titel.localeCompare(b.dataset.titel, 'de'); });

        var gezeigt = 0;
        liste.forEach(function (k) {
          var passt = chipWert === 'alle' || enthaelt(k, chipKey, chipWert);
          if (passt && begriffe.length) {
            var text = k.dataset.suche || '';
            passt = begriffe.every(function (b) { return text.indexOf(b) !== -1; });
          }
          if (passt) {
            for (var schluessel in wahl) {
              if (!enthaelt(k, schluessel, wahl[schluessel])) { passt = false; break; }
            }
          }
          if (passt && preisAktiv) {
            var preis = parseInt(k.dataset.preis, 10) || 0;
            passt = preis >= preisMin && preis < preisMax;
          }
          if (passt && nurVerfuegbar) passt = k.dataset.verfuegbar === '1';
          k.hidden = !passt;
          if (passt) gezeigt++;
          raster.appendChild(k);         // Reihenfolge im DOM = Reihenfolge im Raster
        });
        if (anzahl) {
          anzahl.textContent = gezeigt === 1 ? werkEins : werkViele.replace('{n}', gezeigt);
        }
        if (keine) keine.hidden = gezeigt > 0;

        var aktiv = begriffe.length > 0 || chipWert !== 'alle' || preisAktiv || nurVerfuegbar;
        for (var egal in wahl) { aktiv = true; break; }
        if (zurueck) zurueck.hidden = !aktiv;

        /* Was in der Leiste steckt, zählt am Knopf mit — die Gattung
           nicht, die zeigt ihre Liste selbst an; die Suche steht oben. */
        var inLeiste = [];
        facetten.forEach(function (f) {
          if (f.value) inLeiste.push({ feld: f, text: f.options[f.selectedIndex].text });
        });
        if (preisAktiv) inLeiste.push({ feld: preisSel, text: preisSel.options[preisSel.selectedIndex].text });
        if (nurVerfuegbar) inLeiste.push({ feld: verfuegbar, text: verfuegbar.textContent.trim() });
        if (klappZahl) {
          klappZahl.textContent = inLeiste.length;
          klappZahl.closest('.klapp').classList.toggle('is-aktiv', inLeiste.length > 0);
        }
        if (mobilZahl) {
          mobilZahl.textContent = inLeiste.length;
          mobilZahl.classList.toggle('is-da', inLeiste.length > 0);
        }
        if (marken) {
          marken.textContent = '';
          inLeiste.forEach(function (m) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'marke';
            b.textContent = m.text;
            b.insertAdjacentHTML('beforeend', '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>');
            b.addEventListener('click', function () {
              if (m.feld === verfuegbar) {
                verfuegbar.setAttribute('aria-pressed', 'false');
                verfuegbar.classList.remove('is-active');
              } else {
                m.feld.value = '';
              }
              anwenden();
            });
            marken.appendChild(b);
          });
          marken.hidden = inLeiste.length === 0;
        }

        neuOrdnen();
      };

      if (chips) {
        chips.addEventListener('click', function (e) {
          var b = e.target.closest('[data-wert]');
          if (!b) return;
          chips.querySelectorAll('[data-wert]').forEach(function (c) {
            var an = c === b;
            c.classList.toggle('is-active', an);
            c.setAttribute('aria-pressed', an);
          });
          anwenden();
        });
      }
      if (sortSel) sortSel.addEventListener('change', anwenden);
      facetten.forEach(function (f) { f.addEventListener('change', anwenden); });
      if (preisSel) preisSel.addEventListener('change', anwenden);
      if (verfuegbar) {
        verfuegbar.addEventListener('click', function () {
          var an = verfuegbar.getAttribute('aria-pressed') === 'true';
          verfuegbar.setAttribute('aria-pressed', an ? 'false' : 'true');
          verfuegbar.classList.toggle('is-active', !an);
          anwenden();
        });
      }
      if (suchFeld) {
        var tippPause;
        var suchen = function () { clearTimeout(tippPause); tippPause = setTimeout(anwenden, 160); };
        suchFeld.addEventListener('input', suchen);
        suchFeld.addEventListener('search', anwenden); // ×-Knopf des Feldes
      }
      if (zurueck) {
        zurueck.addEventListener('click', function () {
          if (suchFeld) suchFeld.value = '';
          facetten.forEach(function (f) { f.value = ''; });
          if (preisSel) preisSel.value = '';
          if (verfuegbar) {
            verfuegbar.setAttribute('aria-pressed', 'false');
            verfuegbar.classList.remove('is-active');
          }
          if (chips) {
            chips.querySelectorAll('[data-wert]').forEach(function (c) {
              var an = c.dataset.wert === 'alle';
              c.classList.toggle('is-active', an);
              c.setAttribute('aria-pressed', an);
            });
          }
          anwenden();
        });
      }
    }

    /* Bilder ohne bekannte Maße verschieben die Höhe erst beim Laden. */
    raster.querySelectorAll('img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', neuOrdnen, { once: true });
      img.addEventListener('error', neuOrdnen, { once: true });
    });

    neuOrdnen();

    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(neuOrdnen, 120); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(neuOrdnen);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initGalerie(); });
  } else {
    initGalerie();
  }

  /* Theme-Editor: Section neu geladen → Raster neu vermessen. */
  document.addEventListener('shopify:section:load', function (e) { initGalerie(e.target); });
})();
